<template>
<div class="container m-t-5 m-b-10">

    <p class="title heading ">Hasta 12 cuotas de <span class="has-text-success is-size-5">{{currency}} {{doce}}</span> por medio de</p>
    <div class="level is-mobile">
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/master.svg" alt="">
            </div>
        </div>
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/visa.svg" alt="">
            </div>
        </div>
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/oca.svg" alt="">
            </div>
        </div>
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/lider.svg" alt="">
            </div>
        </div>
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/diners.svg" alt="">
            </div>
        </div>
        <div class="level-item">
            <div>
                <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/svg-pay-logos/cabal.svg" alt="">
            </div>
        </div>
    </div>
    <hr/>
</div>    
</template>

<script>
export default {
    props:{
        currency:{
            type:String,
            default:""
        },
        price:{
            type:Number,
            default:0
        }
    },
    computed:{
        doce(){
            return parseFloat(this.price/12).toFixed(2)
        },
        dieciocho(){
            return parseFloat(this.price/18).toFixed(2)
        },
        diez(){
            return parseFloat(this.price/10).toFixed(2)
        }
    }
}
</script>

<style lang="scss" scoped>
.media{
    padding:0px;
    margin:0px;
}
.media-content{
    padding:0px;
    margin:0px;
}
</style>